import clsx from 'clsx'
import format from 'date-fns/format'
import React, { useContext, useState } from 'react'
import { FareTableStateContext } from '../../contexts/fareTableData'
import './tnc.css'

const TnC = () => {
  const [fareData] = useContext(FareTableStateContext)
  const [showClaims, setShowClaims] = useState(false)
  const [showConditions, setShowConditions] = useState(false)
  const handleTaxesNFeesClick = e => {
    window.open(
      'https://www.airtkt.com/res/taxes_fees.php',
      'TaxesnFees',
      'status=yes,scrollbars=yes,width=900,height=900'
    )
  }

  const handleTnCClick = e => {
    window.open(
      'https://www.airtkt.com/book/support/category.php?cat=terms',
      'TnC',
      'status=yes,scrollbars=yes,width=900,height=900'
    )
  }

  return (
    <div className='tnc-container'>
      <div
        className={clsx('tnc-heading', showClaims && 'tnc-heading-border')}
        onClick={() => setShowClaims(!showClaims)}
      >
        <strong>
          [{showClaims ? '-' : '+'}] Airfare, Discounts and Saving Claims
        </strong>
      </div>
      {showClaims && (
        <div className='claims-content'>
          {!!fareData && (
            <p>
              {' '}
              * The economy class fare displayed on ad $
              {fareData.fare_detail.fare} was found on{' '}
              {format(Date.now(), 'DD MMM YY')} between{' '}
              {fareData.from.airportCode} and {fareData.to.airportCode}, depart{' '}
              {format(fareData.fare_detail.depart_dt, 'DD MMM YY')}{' '}
              {!!fareData.fare_detail.return_dt && (
                <>
                  {' '}
                  - return {format(fareData.fare_detail.return_dt, 'DD MMM YY')}
                </>
              )}
              .
            </p>
          )}
          <p>
            {' '}
            * Discount is applicable on unrestricted published economy class
            airfare of most major scheduled airlines. These offers are good on
            major airlines to all destinations world wide. All fares are subject
            to availability.Discount may vary based on availability, season,
            travel dates, advance notice, minimum maximum stay, black out travel
            dates and may change without any prior notice.Additional
            restrictions may apply. This site pays most careful attention in
            providing information and data, but it does not guarantee the
            correctness, completeness, and the usefulness of its contents.
          </p>
          <p>
            {' '}
            * Displayed fares are based on historical data, are subject to
            change and cannot be guaranteed at the time of booking. Total fare
            round trip economy class per person in US dollars, including all{' '}
            <button className='tnc-link' onClick={handleTaxesNFeesClick}>
              taxes and fees
            </button>
            .
          </p>
          <p>
            {' '}
            * Sample fares shown are from recent customer searches, updates
            every day. Sample fares are subject to change based on availability
            and travel dates. Additional restrictions may apply.
          </p>
          <p>
            * As compared to the applicable classes of international and
            domestic unrestricted published airfares. This comparison is done
            live at the time of flight search and based on identical itinerary
            in real time.
          </p>
        </div>
      )}

      <div
        className={clsx('tnc-heading', showConditions && 'tnc-heading-border')}
        onClick={() => setShowConditions(!showConditions)}
      >
        <strong>
          [{showConditions ? '-' : '+'}] Booking Terms and Conditions
        </strong>
      </div>
      {showConditions && (
        <div className='tnc-content'>
          <ul className='othInf'>
            <li>Fares are round trip and inclusive of all taxes and fee.</li>
            <li>
              Tickets are non refundable, non transferable &amp; non-assignable.
            </li>
            <li>Name changes are not permitted.</li>
            <li>Fares are subject to availability.</li>
            <li>
              There is a higher probability of seats being available at this
              fare on a week day and most discounted fare may require an advance
              purchase ranging from 5 to 21 days.
            </li>
            <li>
              Blackout dates may apply, holidays and Weekend travel may have a
              surcharge.
            </li>
            <li>
              Subject to the fare type, additional{' '}
              <button className='tnc-link' onClick={handleTnCClick}>
                terms and conditions
              </button>{' '}
              may apply.
            </li>
          </ul>
        </div>
      )}
    </div>
  )
}

export default TnC
